/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import AccountSummaryVo from './AccountSummaryVo';
import CompanyBaseVo from './CompanyBaseVo';
import DrillKnowledgeVo from './DrillKnowledgeVo';




  /**
   * The DrillVo model module.
   * @module drill/model/DrillVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>DrillVo</code>.
   * @alias module:drill/model/DrillVo
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>DrillVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/DrillVo} obj Optional instance to populate.
   * @return {module:drill/model/DrillVo} The populated <code>DrillVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'required')) {
        obj['required'] = ApiClient.convertToType(data['required'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'subType')) {
        obj['subType'] = ApiClient.convertToType(data['subType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'text')) {
        obj['text'] = ApiClient.convertToType(data['text'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'knowledgeList')) {
        obj['knowledgeList'] = ApiClient.convertToType(data['knowledgeList'], [DrillKnowledgeVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'company')) {
        obj['company'] = CompanyBaseVo.constructFromObject(data['company']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'createAccount')) {
        obj['createAccount'] = AccountSummaryVo.constructFromObject(data['createAccount']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 必学
   * @member {Boolean} required
   */
  exports.prototype['required'] = undefined;
  /**
   * 题型
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 子题型
   * @member {Integer} subType
   */
  exports.prototype['subType'] = undefined;
  /**
   * 云教材小节内题序号（仅当查询section下题目时有值）
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;
  /**
   * 题干
   * @member {String} text
   */
  exports.prototype['text'] = undefined;
  /**
   * 关联课程目标知识点
   * @member {Array.<module:drill/model/DrillKnowledgeVo>} knowledgeList
   */
  exports.prototype['knowledgeList'] = undefined;
  /**
   * 上传碎片的院校
   * @member {module:drill/model/CompanyBaseVo} company
   */
  exports.prototype['company'] = undefined;
  /**
   * @member {module:drill/model/AccountSummaryVo} createAccount
   */
  exports.prototype['createAccount'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 修改时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;



  export default exports;
;


